import React, { useEffect, useState } from "react";

// components
import { Button, Card, CardBody, CardHeader, Form, Row, Col, Spinner } from "reactstrap";
import MaterialTable from 'material-table';

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// views
import PenalidadeFicha from "./PenalidadeFicha";

// helpers
import { showMessage } from "../../../helpers/message";

// api
import penalidade_api from "../../../api/penalidade_api.js";
import usuario_api from "../../../api/usuario_api.js";

export default function PenalidadeLista() {

  const [showLoading, setshowLoading] = React.useState(false);

  const [list_table, set_list_table] = React.useState([]);
  const [rowEdit, set_rowEdit] = React.useState(null);
  const [showDetail, set_showDetail] = React.useState(false);
  const [isDisable, set_isDisable] = useState(true);

  const handleAdd = () => {
    set_rowEdit(null);
    set_showDetail(true);
  }

  const handleEdit = (rowData) => {
    setshowLoading(true);
    penalidade_api.getItem(rowData.penalidade_Id).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_rowEdit(result.data);
        set_showDetail(true);
      }
    });
  }

  const handleReturn = () => {
    set_rowEdit(null);
    set_showDetail(false);
    loadList();
  }

  const loadList = () => {
    setshowLoading(true);
    penalidade_api.getAll().then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_list_table(result.data);
      }
    });
  }

  useEffect(() => {
    usuario_api.getFuncionalidadeAcaoLiberada("CadastroPenalidade", "Editar").then((result) => { set_isDisable(!result); });

    loadList();
  }, []);

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <Spinner></Spinner>
          </div>
        </div>
      }
      <div className={showDetail ? "d-none" : "content"}>
        <Row>
          <Col md="12">
            {!isDisable && <Button color="default" onClick={handleAdd}>
              <i className="fa fa-plus"></i>  Nova Penalidade
            </Button>
            }
            <Card>
              <CardHeader>
                <h4 className="titleCard">Lista de Penalidades</h4>
              </CardHeader>
              <CardBody>
                <Form>
                  <MaterialTable style={{ minHeight: "auto" }}
                    title=""
                    columns={[
                      { title: 'Descrição', field: 'descricao' },
                      { title: 'Status', field: 'status' }
                    ]}
                    data={list_table}
                    isLoading={false}
                    options={{
                      ...table_style,
                      filtering: false,
                      exportButton: true
                    }}
                    actions={[
                      {
                        icon: 'search',
                        tooltip: 'Visualizar Registro',
                        onClick: (event, rowData) => handleEdit(rowData)
                      }
                    ]}
                    localization={table_translate}
                  />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      {showDetail &&
        <PenalidadeFicha
          item={rowEdit}
          handleReturn={handleReturn}
        />
      }
    </>

  );
}